import React, { Component } from 'react';
import { Col, Row, Card, CardBody, Button } from "reactstrap";
import { goBackPassengers } from "../../redux/actions/ticket";
import { connect } from "react-redux";


class PassengersreviewDetail extends Component {


    render() {
        const { data } = this.props;
        // console.log(data)
        return (
            <div className="PassengersreviewDetail" >
                {data.map((item, i) => {
                    return (
                        <div key={i}>
                            <Card className="white mb-3 w-100 flight-item padding-for-cart">
                                <CardBody>

                                    {item.DocIssuedCountry === "IR" ?
                                        <div className="review-persian-passenger">
                                            <Row>
                                                <Col md={4} >
                                                    <div className="pasenger-title-review">
                                                        First Name
                                                </div>
                                                    <div className="pasenger-content-review">
                                                        {item.name}
                                                    </div>
                                                </Col>
                                                <Col md={4} >
                                                    <div className="pasenger-title-review">
                                                        Last Name:
                                                </div>
                                                    <div className="pasenger-content-review">
                                                        {item.family}
                                                    </div>
                                                </Col>
                                                <Col md={4} >
                                                    <div className="pasenger-title-review">
                                                        Birth Date:
                                                </div>
                                                    <div className="pasenger-content-review">
                                                        {item.BirthDate}
                                                    </div>
                                                </Col>
                                            </Row>
                                            <Row>
                                                <Col md={4} >
                                                    <div className="pasenger-title-review">
                                                        Gender:
                                                </div>
                                                    <div className="pasenger-content-review">
                                                        {item.Gender === 1 ? 'Male' : 'Female'}
                                                    </div>
                                                </Col>
                                                <Col md={4} >
                                                    <div className="pasenger-title-review">
                                                        Type :
                                                </div>
                                                    <div className="pasenger-content-review">
                                                        {item.PassengerType === 1 ? 'Adult' : item.PassengerType === 2 ? 'Child' : 'Infant'}
                                                    </div>
                                                </Col>
                                                <Col md={4} >
                                                    <div className="pasenger-title-review">
                                                        National ID:
                                                </div>
                                                    <div className="pasenger-content-review">
                                                        {item.nationalId}
                                                    </div>
                                                </Col>



                                            </Row>
                                        </div>
                                        :
                                        <div className="review-forgen-passenger">
                                            <Row>
                                                <Col md={3} >
                                                    <div className="pasenger-title-review">
                                                        First Name
                                                </div>
                                                    <div className="pasenger-content-review">
                                                        {item.name}
                                                    </div>
                                                </Col>
                                                <Col md={3} >
                                                    <div className="pasenger-title-review">
                                                        Last Name:
                                                </div>
                                                    <div className="pasenger-content-review">
                                                        {item.family}
                                                    </div>
                                                </Col>
                                                <Col md={3} >
                                                    <div className="pasenger-title-review">
                                                        Gender:
                                                </div>
                                                    <div className="pasenger-content-review">
                                                        {item.Gender === 1 ? 'Male' : 'Female'}
                                                    </div>
                                                </Col>
                                                <Col md={3} >
                                                    <div className="pasenger-title-review">
                                                        Type :
                                                    </div>
                                                    <div className="pasenger-content-review">
                                                        {item.PassengerType === 1 ? 'Adult' : item.PassengerType === 2 ? 'Child' : 'Infant'}
                                                    </div>
                                                </Col>
                                            </Row>
                                            <Row>
                                                <Col md={3} >
                                                    <div className="pasenger-title-review">
                                                        Birth Date:
                                                    </div>
                                                    <div className="pasenger-content-review">
                                                        {item.BirthDate}
                                                    </div>
                                                </Col>
                                                <Col md={3} >
                                                    <div className="pasenger-title-review">
                                                        Passport No:
                                                </div>
                                                    <div className="pasenger-content-review">
                                                        {item.passportId}
                                                    </div>
                                                </Col>
                                                <Col md={3} >
                                                    <div className="pasenger-title-review">
                                                        Passport Expired Date:
                                                </div>
                                                    <div className="pasenger-content-review">
                                                        {item.passportExpire}
                                                    </div>
                                                </Col>
                                            </Row>
                                        </div>

                                    }


                                </CardBody>
                            </Card>

                        </div>
                    )
                })
                }
                <Card className="white mb-3 w-100 flight-item padding-for-cart">
                    <CardBody>
                        <div>
                            <p>
                                If there is any diffrence between this infrmation and yours, push Go Back button and change it.
                            </p>
                            <Button onClick={() => {
                                this.props.goBackPassengers(true);
                                window.location.replace('/ticket-passengers')
                            }
                            }>Go Back</Button>
                        </div>
                    </CardBody>
                </Card>
            </div>
        )
    }
}

const mapDispatchToProps = dispatch => {
    return {
        goBackPassengers: (goback) => {
            dispatch(goBackPassengers(goback))
        }
    }
};
export default connect(null, mapDispatchToProps)(PassengersreviewDetail)


// WEBPACK FOOTER //
// ./src/components/review/PassengersreviewDetail.jsx